import React from 'react'

const EditGallery = () => {
  return (
    <div>
      
    </div>
  )
}

export default EditGallery
